// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{margin:0;padding:0}body,body #app,html,html #app{width:100%;height:100%}::-webkit-scrollbar{width:.104vw;height:1px}::-webkit-scrollbar-thumb{border-radius:.26vw;background-color:#af4af0}::-webkit-scrollbar-track{box-shadow:inset 0 0 .26vw rgba(0,0,0,.2);background:#ededed;border-radius:.26vw}", ""]);
// Exports
module.exports = exports;
